import { fontSize, margin, width } from "@mui/system";
import "../css/theme.css";
import { useTheme } from "../OAS365Theme";

/** Shared height for toolbar search inputs and adjacent filter controls. */
export const TOOLBAR_SEARCH_CONTROL_HEIGHT = "40px";

/** Same outer box for search field and Filters button (height includes border). */
export const toolbarControlDimensions = {
  height: TOOLBAR_SEARCH_CONTROL_HEIGHT,
  minHeight: TOOLBAR_SEARCH_CONTROL_HEIGHT,
  maxHeight: TOOLBAR_SEARCH_CONTROL_HEIGHT,
  boxSizing: "border-box",
};

export const useSearchPanel = () => {
  const theme = useTheme();
  const searchPanelStyle = {
    SearchBarMainDivStyle: searchBarMainDiv(theme),
    SearchbyLableStyle: searchbyLable(theme),
    SearchbyLanguageLableStyle: searchbyLanguage(theme),
    SearchTextBoxStyle: searchTextBox(theme),
    ToolBarSearchTextBoxStyle: toolBarSearchTextBox(theme),
    SearchButtonStyle: searchButton(theme),
    SearchButtonToolBarStyle: searchButtonToolBar(theme),
    SearchButtonDisabledStyle: searchButtonDisabled(theme),
    SearchButtonToolBarDisabledStyle: searchButtonToolBarDisabled(theme),
    StackToggleStyles: stackToggle(theme),
    StackSearchBarStyles: stackSearchBar(theme),
    ToolBarStyles: toolBarSearchBar(theme),
    ToolBarStylesHighlight: toolBarSearchBarHighlight(theme),
    StackSearchClearPanelStyles: stackSearchClearPanel(theme),
    StackSearchClearButtonStyles: stackSearchClearButton(theme),
    StackSearchClearButtonToolBarStyles: stackSearchClearButtonToolBar(theme),
    StackSearchClearButtonDisableStyles: stackSearchClearButtonDisable(theme),
    StackSearchClearButtonToolBarDisableStyles:
      stackSearchClearButtonToolBarDisable(theme),
    StackStyles: stackStyles(theme),
    StackSearchButtonStyles: stackSearchButton(theme),
    StackSearchLabalStyles: stackSearchLabal(theme),
    BasicToggleStyles: basicToggle(theme),

    FilterButtonContainerStyle: filterButtonContainer(theme),
    FilterButtonStyle: filterButton(theme),
    FileTypeButtonContainerStyle: fileTypeButtonContainer(theme),
    FileTypeButtonContainerSelectedStyle:
      fileTypeButtonContainerSelected(theme),
    FileTypeButtonStyle: fileTypeButton(theme),
    FileTypeTextStyle: fileTypeText(theme),
    IconImageStyle: iconImage(theme),
    PdfFilterIconImageStyle: pdfFilterIconImage(theme),
    AccessButtonContainerStyle: accessButtonContainer(theme),
    AccessButtonContainerSelectedStyle: accessButtonContainerSelected(theme),
    AccessButtonStyle: accessButton(theme),
  };
  return searchPanelStyle;
};

const searchBarMainDiv = (theme) => {
  const style = {
    padding: "0px 0px 5px 0px",
    "box-sizing": "border-box",
    "border-radius": "8px",
  };
  return style;
};

const searchbyLable = (theme) => {
  const style = {
    position: "relative",
    left: "8px",
    top: "0px",
    "font-family": theme.fonts.regular,
    "font-style": theme.fontStyle.normal,
    "font-weight": theme.fontWeight.normal,
    "font-size": theme.fontSizes.normal,
    "line-height": theme.lineHeight.lable,
    color: theme.colors.fontColor,
  };
  return style;
};

const searchbyLanguage = (theme) => {
  const style = {
    position: "relative",
    left: "0px",
    top: "0px",
    "font-family": theme.fonts.regular,
    "font-style": theme.fontStyle.normal,
    "font-weight": theme.fontWeight.normal,
    "font-size": theme.fontSizes.normal,
    "line-height": theme.lineHeight.lable,
    color: theme.colors.themeDarkColor,
  };
  return style;
};

const searchTextBox = (theme) => {
  const style = {
    padding: "12px 20px",
    border: "none",
    transition: "0.5s",
    backgroundColor: "transparent",
    color: theme.colors.fontColor,
    outline: "none",
    fontFamily: theme.fonts.regular,
  };
  return style;
};

const searchButton = (theme) => {
  const style = {
    background: theme.colors.themeDarkColor,
    color: theme.colors.buttonTextColor,
    borderRadius: "50%",
    padding: "2px",
    width: "18px",
    height: "18px",
    right: "5px",
    fontSize: "12px",
  };
  return style;
};

const searchButtonDisabled = (theme) => {
  const style = {
    background: "red",
    color: theme.colors.addovationWhite,
    borderRadius: "50%",
  };
  return style;
};

const searchButtonToolBar = (theme) => {
  const style = {
    background: "transparent",
    color: theme.colors.buttonTextColor,
    borderRadius: "50%",
    padding: "2px",
    width: "19px",
    height: "19px",
    right: "5px",
    fontSize: "12px",
  };
  return style;
};

const searchButtonToolBarDisabled = (theme) => {
  const style = {
    background: "transparent",
    color: theme.colors.addovationWhite,
    borderRadius: "50%",
    padding: "2px",
    width: "19px",
    height: "19px",
    right: "5px",
    fontSize: "12px",
  };
  return style;
};

const stackSearchClearButton = (theme) => {
  const style = {
    background: "none",
    color: theme.colors.fontColor,
    borderRadius: "50%",
    padding: "8px",
  };
  return style;
};

const stackSearchClearButtonToolBar = (theme) => {
  const style = {
    background: theme.colors.addovationWhite,
    color: theme.colors.addovation70Green,
    borderRadius: "50%",
    padding: "2px",
    width: "18px",
    height: "18px",
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    marginTop: "0.3px",
    selectors: {
      "& .ms-Button-icon": {
        fontSize: theme.fontSizes.normal,
        fontFamily: theme.fonts.regular,
      },
    },
  };
  return style;
};

const stackSearchClearButtonToolBarDisable = (theme) => {
  const style = {
    background: "transparent",
    color: theme.colors.cancleBtnDisable,
    borderRadius: "50%",
    padding: "2px",
    width: "18px",
    height: "18px",
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    marginTop: "0.3px",
    selectors: {
      "& .ms-Button-icon": {
        fontSize: theme.fontSizes.normal,
        fontFamily: theme.fonts.regular,
      },
    },
  };
  return style;
};

const stackSearchClearButtonDisable = (theme) => {
  const style = {
    background: "none",
    color: theme.colors.cancleBtnDisable,
    borderRadius: "50%",
    padding: "8px",
  };
  return style;
};

const stackToggle = (theme) => {
  const style = {
    root: {
      alignItems: "center",
      justifyContent: "center",
      display: "inline-grid",
      "justify-content": "left",
      padding: "0px 1px 0px 4px",
    },
  };
  return style;
};

const toolBarSearchBar = (theme) => {
  const style = {
    root: {
      ...toolbarControlDimensions,
      border: "2px solid " + theme.colors.Addovation20Grey,
      borderRadius: "20px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "0",
      overflow: "hidden",
    },
  };
  return style;
};

const toolBarSearchBarHighlight = (theme) => {
  const style = {
    root: {
      ...toolbarControlDimensions,
      border: "2px solid " + theme.colors.addovation70Green,
      borderRadius: "20px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "0",
      overflow: "hidden",
    },
  };
  return style;
};

const toolBarSearchTextBox = (theme) => {
  const style = {
    padding: "2px 10px",
    border: "none",
    transition: "0.5s",
    backgroundColor: "transparent",
    color: theme.colors.fontColor,
    outline: "none",
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.normal,
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    lineHeight: "normal",
  };
  return style;
};

const stackSearchBar = (theme) => {
  const style = {
    root: {
      borderRadius: "30px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "-webkit-fill-available",
      height: "28px",
    },
  };
  return style;
};

const stackSearchClearPanel = (theme) => {
  const style = {
    root: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    },
  };
  return style;
};

const stackStyles = (theme) => {
  const style = {
    root: {
      // background: theme.colors.backgroundColor,
      width: "65%",
    },
  };
  return style;
};

const stackSearchButton = (theme) => {
  const style = {
    root: {
      display: "contents",
    },
  };
  return style;
};

const stackSearchLabal = (theme) => {
  const style = {
    root: {
      display: "inline-grid",
    },
  };
  return style;
};

const basicToggle = (theme) => {
  const style = {
    root: {
      ".ms-Toggle-background": {
        //background: theme.colors.addovationWhite,
        // borderColor: theme.colors.addovation30Gray,
      },
      ".ms-Toggle-thumb": {
        "border-style": "inherit",
        "border-width": "thin",
      },

      '[aria-checked="true"]': {
        background: theme.colors.themeDarkColor,
        ".ms-Toggle-thumb": {
          // background: theme.colors.addovationWhite,
          // "border-color": theme.colors.addovation10Gray,
        },
      },
      '[aria-checked="false"]': {
        ".ms-Toggle-thumb": {
          background: theme.colors.addovation30Gray,
          "border-color": theme.colors.addovation10Gray,
        },
      },

      selectors: {
        ":hover .ms-Toggle-background": {
          background: theme.colors.addovationWhite,
          borderColor: theme.colors.themeDarkColor,
        },
        ":hover .ms-Toggle-thumb": {
          borderColor: theme.colors.addovation50Green,
          background: theme.colors.themeDarkColor,
        },
      },
    },
    pill: {
      ":hover .ms-Toggle-thumb": {
        "background-color": theme.colors.themeDarkColor,
        "border-color": theme.colors.addovation50Green,
        "border-width": "thin",
      },
    },
  };
  return style;
};

const filterButtonContainer = (theme) => {
  const style = {
    ...toolbarControlDimensions,
    border: `1px solid ${theme.colors.addovation30Gray}`,
    width: "66px",
    minWidth: "66px",
    maxWidth: "66px",
    borderRadius: "20px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    cursor: "pointer",
    backgroundColor: "transparent",
  };
  return style;
};

const filterButton = (theme) => {
  const style = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    width: "100%",
    height: "100%",
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
    color: theme.colors.fontColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return style;
};

const fileTypeButtonContainer = (theme) => {
  const style = {
    ...toolbarControlDimensions,
    border: `1px solid ${theme.colors.addovation30Gray}`,
    borderRadius: "20px",
    padding: "2px 12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "2px",
    cursor: "pointer",
    backgroundColor: "transparent",
  };
  return style;
};

const fileTypeButtonContainerSelected = (theme) => {
  const style = {
    ...toolbarControlDimensions,
    boxShadow: `
      inset 0 0 0 1.5px #4c8d6a,
      0 0 2px 2px #4c8d6a40
    `,
    borderRadius: "20px",
    padding: "2px 12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "2px",
    cursor: "pointer",
    backgroundColor: "transparent",
  };
  return style;
};

const fileTypeButton = (theme) => {
  const style = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "2px",
  };
  return style;
};

const fileTypeText = (theme) => {
  const style = {
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
    color: theme.colors.fontColor,
    whiteSpace: "nowrap",
  };
  return style;
};

const iconImage = (theme) => {
  const style = {
    width: "20px",
    height: "20px",
    marginRight: "4px",
  };
  return style;
};

const pdfFilterIconImage = (theme) => ({
  ...iconImage(theme),
  width: "17px",
  height: "17px",
});

const accessButtonContainer = (theme) => {
  const style = {
    border: `1px solid ${theme.colors.addovation30Gray}`,
    height: "25.5px",
    width: "50px",
    borderRadius: "20px",
    padding: "2px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",

    backgroundColor: "transparent",
  };
  return style;
};

const accessButtonContainerSelected = (theme) => {
  const style = {
    border: `1px solid ${theme.colors.fontColor}`,
    height: "25.5px",
    width: "50px",
    borderRadius: "20px",
    padding: "2px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",

    backgroundColor: theme.colors.addovation70Green,
  };
  return style;
};

const accessButton = (theme) => {
  const style = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  };
  return style;
};
